// extracted by mini-css-extract-plugin
module.exports = {"box":"sortpage_box__QvZMx","open":"sortpage_open__kiXgf","wrapper":"sortpage_wrapper__oqXbI"};